module.exports = __webpack_public_path__ + "19098ea66373e49fc9a57e1b777beb66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-gurasann.png
// module id = 2091
// module chunks = 4